import React from 'react';
import Modal from 'react-modal';

interface Props extends Modal.Props {
  styledContent: React.ComponentType<React.HTMLAttributes<HTMLElement>>;
  styledOverlay: React.ComponentType<React.HTMLAttributes<HTMLElement>>;
}

export const StyledModal: React.FC<Props> = ({ children, styledContent: StyledContent, styledOverlay: StyledOverlay, ...props }) => {
  const overlayCloseHandler = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    if (props.shouldCloseOnOverlayClick && props?.onRequestClose) {
      props.onRequestClose(event);
    }
  };
  return (
    <Modal
      className="_"
      overlayClassName="_"
      contentElement={(modalProps, modalChildren) => (
        <StyledContent {...modalProps} onClick={overlayCloseHandler}>
          {modalChildren}
        </StyledContent>
      )}
      overlayElement={(modalProps, contentElem) => <StyledOverlay {...modalProps}>{contentElem}</StyledOverlay>}
      {...props}
    >
      {children}
    </Modal>
  );
};

export const afterModalOverlayOpen = () => {
  return '&.ReactModal__Overlay--after-open';
};

export const beforeModalOverlayClose = () => {
  return '&.ReactModal__Overlay--before-close';
};

export const afterModalContentOpen = (parent?: React.ComponentType<React.HTMLAttributes<HTMLElement>>) => {
  return `${parent ?? ''}.ReactModal__Content--after-open &`;
};

export const beforeModalContentClose = (parent?: React.ComponentType<React.HTMLAttributes<HTMLElement>>) => {
  return `${parent ?? ''}.ReactModal__Content--before-close &`;
};
